import {
  FaChartArea,
  FaHourglassHalf,
  FaUser,
  FaUsers,
  FaSitemap,
  FaBusinessTime,
  FaXRay,
  FaRegEnvelope,
} from 'react-icons/fa';

import allRoles from 'core/roles';
import messages from './messages';

// only one isMain Nav is allowed and needed
const navTree = showWorkCategory => [
  {
    name: messages.dashboard,
    mainNav: {
      name: messages.dashboard,
      path: '/admin/dashboard',
      roles: [],
    },
    subNavs: [],
    openIcon: FaChartArea,
    closedIcon: FaChartArea,
  },
  {
    name: messages.hours,
    mainNav: {
      name: messages.hours,
      path: '/admin/hours',
      roles: [],
    },
    subNavs: [],
    openIcon: FaHourglassHalf,
    closedIcon: FaHourglassHalf,
  },
  {
    name: messages.account,
    mainNav: {
      name: messages.account,
      path: '/admin/account',
      roles: [],
    },
    subNavs: [],
    openIcon: FaUser,
    closedIcon: FaUser,
  },
  {
    name: messages.users,
    mainNav: {
      name: messages.users,
      path: '/admin/users',
      roles: [allRoles.ADMIN],
    },
    subNavs: [],
    openIcon: FaUsers,
    closedIcon: FaUsers,
  },
  {
    name: messages.shortWork,
    mainNav: {
      name: messages.shortWork,
      path: '/admin/short-work',
      roles: [allRoles.ADMIN],
    },
    subNavs: [],
    openIcon: FaBusinessTime,
    closedIcon: FaBusinessTime,
  },
  {
    name: messages.projects,
    mainNav: {
      name: messages.projects,
      path: '/admin/projects',
      roles: [allRoles.ADMIN, allRoles.PROJECT_MANAGER],
    },
    subNavs: [],
    openIcon: FaSitemap,
    closedIcon: FaSitemap,
  },
  {
    name: messages.controlling,
    subNavs: [
      {
        name: messages.projectManagement,
        path: '/admin/controlling/projectManagement',
        roles: [allRoles.ADMIN, allRoles.PROJECT_MANAGER],
      },
      {
        name: messages.issueManagement,
        path: '/admin/controlling/issueManagement',
        oAuthProvider: 'gitlab',
        roles: [allRoles.ADMIN, allRoles.PROJECT_MANAGER],
      },
      {
        name: messages.detailedRatios,
        path: '/admin/controlling/detailedRatios',
        roles: [allRoles.ADMIN, allRoles.PROJECT_MANAGER],
      },
      showWorkCategory && {
        name: messages.workCategoryManagement,
        path: '/admin/controlling/workCategoryManagement',
        roles: [allRoles.ADMIN, allRoles.PROJECT_MANAGER],
      },
    ],
    mainNav: {
      name: messages.controlling,
      path: '/admin/controlling/ratios',
      roles: [allRoles.ADMIN, allRoles.PROJECT_MANAGER],
    },
    openIcon: FaXRay,
    closedIcon: FaXRay,
  },
  {
    name: messages.notifications,
    mainNav: {
      name: messages.notifications,
      path: '/admin/notifications',
      roles: [allRoles.ADMIN],
    },
    subNavs: [],
    openIcon: FaRegEnvelope,
    closedIcon: FaRegEnvelope,
  },
];

export default navTree;
